import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/ui/Header';
import AIChatbot from '../../components/ui/AIChatbot';
import TeamManagementTab from '../pcf-admin-dashboard/components/TeamManagementTab';

const CityOfficialTeamsPage = () => {
  const { user, userProfile } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <Header 
        userRole="city-official" 
        userName={userProfile?.full_name}
        notifications={3}
      />
      
      <main className="container mx-auto px-4 py-6 lg:px-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-foreground mb-2">My Teams</h1>
          <p className="text-muted-foreground">
            Monitor and manage teams assigned to your problem statements
          </p>
        </div>

        <div className="bg-card border border-border rounded-lg shadow-soft">
          <div className="p-6">
            {/* Reuse PCF Admin TeamManagementTab with city official filter */}
            <TeamManagementTab filterByCityOfficial={user?.id} />
          </div>
        </div>
      </main>
      
      <AIChatbot userRole="city_official" userId={user?.id} />
    </div>
  );
};

export default CityOfficialTeamsPage;